import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/ecoTrail-hero.jpg";
import bus from "../assets/bus.png";


import img from "../assets/exploring-sri-lanka.jpg";

function CustomTourPackages() {
    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    const [showForm, setShowForm] = useState(false);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        country: "",
        email: "",
        code: "",
        phone: "",
        whatsapp: "",
        arrivalDate: "",
        pickup: "",
        departureDate: "",
        pax: "",
        children: "",
        hotel: "",
        rooms: "",
        budget: "",
        interests: [],
        tourType: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckbox = (e) => {
        const { value, checked } = e.target;

        if (checked) {
            setFormData({
                ...formData,
                interests: [...formData.interests, value],
            });
        } else {
            setFormData({
                ...formData,
                interests: formData.interests.filter((i) => i !== value),
            });
        }
    };

    const sendWhatsApp = () => {
        const text = `*New Custom Tour Request* 🚐

        Name: ${formData.firstName} ${formData.lastName}
        Country: ${formData.country}
        Email: ${formData.email}
        Phone: ${formData.code} ${formData.phone}
        WhatsApp: ${formData.whatsapp}

        Arrival: ${formData.arrivalDate}
        Departure: ${formData.departureDate}
        Pickup: ${formData.pickup}

        Pax: ${formData.pax}
        Children: ${formData.children}
        Rooms: ${formData.rooms}
        Hotel: ${formData.hotel}
        Budget: ${formData.budget}

        Interests: ${formData.interests.join(", ")}
        Tour Type: ${formData.tourType}

        Message: ${formData.message}`;

        const url = `https://wa.me/94769245905?text=${encodeURIComponent(text)}`;
        window.open(url, "_blank");
    };

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
                    <h1 className="mb-4 text-4xl font-extrabold sm:text-5xl md:text-6xl">
                        Custom Tour
                    </h1>
                    <p className="max-w-2xl text-sm text-gray-200 sm:text-base">
                        Reliable Taxi & Tour Services Across Sri Lanka
                    </p>
                </div>
            </section>

            {/* FORM */}
            <section className="bg-gray-100 py-16 px-4">
                <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">

                    <div className="bg-white p-8 rounded-lg shadow md:col-span-2">

                        <h2 className="text-3xl font-bold text-center mb-4">
                            Tailor-Made Tours / Custom-Made Tours
                        </h2>

                        <p className="text-center text-gray-600 mb-10">
                            Fill this form and we’ll create your perfect Sri Lanka trip.
                        </p>

                        {/* PERSONAL INFO */}
                        <h3 className="font-semibold mb-4">Personal Information</h3>

                        <div className="grid md:grid-cols-4 gap-4 mb-6">
                            <input name="firstName" placeholder="First Name" onChange={handleChange} className="input" />
                            <input name="lastName" placeholder="Last Name" onChange={handleChange} className="input" />
                            <input name="country" placeholder="Country" onChange={handleChange} className="input" />
                            <input name="email" placeholder="Email" onChange={handleChange} className="input" />

                            <input name="code" placeholder="Country Code" onChange={handleChange} className="input" />
                            <input name="phone" placeholder="Phone Number" onChange={handleChange} className="input" />
                            <input name="whatsapp" placeholder="WhatsApp" onChange={handleChange} className="input" />
                        </div>

                        {/* TOUR INFO */}
                        <h3 className="font-semibold mb-4">Tour Information</h3>

                        <div className="grid md:grid-cols-4 gap-4 mb-6">
                            <input type="date" name="arrivalDate" onChange={handleChange} className="input" />
                            <input name="pickup" placeholder="Pickup Location" onChange={handleChange} className="input" />
                            <input type="date" name="departureDate" onChange={handleChange} className="input" />
                            <input name="pax" placeholder="No of Pax" onChange={handleChange} className="input" />

                            <input name="children" placeholder="Children" onChange={handleChange} className="input" />
                            <input name="hotel" placeholder="Hotel Category" onChange={handleChange} className="input" />
                            <input name="rooms" placeholder="Rooms" onChange={handleChange} className="input" />
                            <input name="budget" placeholder="Budget" onChange={handleChange} className="input" />
                        </div>

                        {/* INTERESTS */}
                        <h3 className="font-semibold mb-2">Interests</h3>
                        <div className="flex flex-wrap gap-4 mb-6">
                            {["Beach", "Adventure", "Culture", "Wildlife", "Relax"].map((item) => (
                                <label key={item}>
                                    <input type="checkbox" value={item} onChange={handleCheckbox} /> {item}
                                </label>
                            ))}
                        </div>

                        {/* TOUR TYPE */}
                        <h3 className="font-semibold mb-2">Tour Type</h3>
                        <div className="flex gap-4 mb-6">
                            {["Solo", "Couple", "Family", "Honeymoon"].map((type) => (
                                <label key={type}>
                                    <input
                                        type="radio"
                                        name="tourType"
                                        value={type}
                                        onChange={handleChange}
                                    />{" "}
                                    {type}
                                </label>
                            ))}
                        </div>

                        {/* MESSAGE */}
                        <textarea
                            name="message"
                            placeholder="Additional Requests"
                            onChange={handleChange}
                            className="w-full border p-3 rounded mb-6"
                            rows={4}
                        />

                        {/* BUTTON */}
                        <div className="text-center">
                            <button
                                onClick={sendWhatsApp}
                                className="bg-teal-600 text-white px-8 py-3 rounded hover:bg-teal-700"
                            >
                                Submit
                            </button>
                        </div>
                    </div>

                    {/* RIGHT → INFO PANEL */}
                    <div className="bg-gray-100 p-6 rounded-lg shadow text-gray-700 md:col-span-1 md:sticky md:top-24 h-fit">

                        <h3 className="text-xl font-semibold mb-3">
                            Custom Tours with Driver
                        </h3>

                        <p className="mb-3">
                            For travelers who already planned their itinerary.
                        </p>

                        <p className="mb-4">
                            Share your dates + destinations and we’ll quote your route with a clear daily rate, including essentials.
                        </p>

                        <h4 className="font-semibold mb-2">Rates</h4>
                        <ul className="list-disc pl-5 mb-4 space-y-2">
                            <li>From Rs. 26,000 / day for tours longer than 7 days</li>
                            <li>Rs. 28,000–30,000 / day for shorter tours</li>
                        </ul>

                        <h4 className="font-semibold mb-2">How it works</h4>
                        <ol className="list-decimal pl-5 space-y-2">
                            <li>Send travel dates + places</li>
                            <li>Choose vehicle (car / van)</li>
                            <li>We confirm driver + quote</li>
                            <li>Travel at your own pace</li>
                        </ol>
                    </div>

                </div>
            </section>

            {/* ================= TAXI CTA ================= */}
            <section className="w-full bg-[#f7f7f7] py-16">
                <div className="mx-auto max-w-7xl px-4 grid md:grid-cols-2 gap-10 items-center">

                    <div className="text-center">
                        <h2 className="mb-4 text-3xl font-extrabold">Book your Taxi Today!</h2>
                        <p className="mb-6 text-gray-700">
                            RNR Travels & Tours is the best and no.1 Taxi & Tour service provider in Sri Lanka.
                        </p>
                        <p className="mb-6 text-2xl font-bold">+94 76 924 5905</p>
                        <a href="tel:+94743205692" className="inline-block rounded bg-black px-8 py-3 text-yellow-400">
                            Contact Us
                        </a>
                    </div>

                    <div className="flex justify-center">
                        <img src={bus} alt="Taxi Service" />
                    </div>

                </div>
            </section>

            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default CustomTourPackages;